export const ACCEPT_COOKIES_KEY = 'cookies-accepted'
